// Bane 6: To hjerter (2050). Kampagnens finale. Fyn og Vestsjælland på hver sin side af Storebælt.
// Danmark har to elsystemer, der slår i hver sin takt: Vestdanmark med kontinentet, Østdanmark med
// Norden. Kun Storebæltsforbindelsen binder dem sammen.
// Nyt: værksnedbrud og frekvens. Når et værk falder ud, dykker frekvensen; svinghjul gør dykket
// mindre. Finalen: storm, et stort værksnedbrud, en kabelskade på Storebælt og et værksnedbrud til.

import type { LevelDef } from '../../sim/types';

export const LEVEL_06: LevelDef = {
  id: '06-to-hjerter',
  number: 6,
  title: 'To hjerter',
  year: 2050,
  intro: 'Danmark har to elhjerter, der slår hver for sig. Hold takten på begge sider af Storebælt, også når et værk falder ud.',
  view: [140, 222, 244, 310],
  greenGoalPct: 80,
  sites: [
    { node: 'odense', kind: 'city', tier: 2, maxTier: 2 },
    { node: 'fynsvaerket', kind: 'plant', name: 'Fynsværket', capMw: 500, green: 1 },
    { node: 'fraugde', kind: 'station' },
    { node: 'herslev', kind: 'station' },
    { node: 'asnaes', kind: 'plant', name: 'Asnæsværket', capMw: 600, green: 1 },
    { node: 'slagelse', kind: 'city', tier: 1, maxTier: 1 },
    { node: 'nyborg', kind: 'city', tier: 0, maxTier: 0, at: [8, 15] },
    // Kunder i køen, skiftevis vest og øst for Storebælt.
    { node: 'korsoer', kind: 'city', tier: 0, maxTier: 0, at: 'pool' },
    { node: 'ringe', kind: 'solar', name: 'Solpark Ringe', capMw: 300, at: 'pool' },
    { node: 'holbaek', kind: 'city', tier: 1, maxTier: 1, at: 'pool' },
    { node: 'sprogoe', kind: 'offshore', name: 'Sprogø Havvind', capMw: 600, fee: 3, at: [64, 72] },
    { node: 'svendborg', kind: 'city', tier: 0, maxTier: 1, at: 'pool' },
    { node: 'ringsted', kind: 'city', tier: 0, maxTier: 1, at: 'pool' },
    { node: 'naestved', kind: 'city', tier: 0, maxTier: 1, at: 'pool' },
  ],
  // Storebælt: 600 MW jævnstrøm mellem Fraugde og Herslev (2010). Værkerne hænger på hver sin by.
  lines: [
    { a: 'fraugde', b: 'herslev', medium: 'hvdc', capMw: 600 },
    { a: 'fynsvaerket', b: 'odense', medium: 'air', tier: 1 },
    { a: 'fraugde', b: 'odense', medium: 'air', tier: 2 },
    { a: 'asnaes', b: 'herslev', medium: 'air', tier: 1 },
    // Slagelse er Vestsjællands knudepunkt og får 400 kV fra start (spilværdi), så byen ikke hænger i en tynd tråd.
    { a: 'herslev', b: 'slagelse', medium: 'air', tier: 2 },
  ],
  mechanics: ['air', 'upgrade', 'double', 'cable', 'sea', 'crew', 'reinforce', 'station', 'shoo', 'battery', 'wishes', 'fcr', 'shed', 'flywheel'],
  eventMenu: ['storm', 'digger', 'anchor', 'protest', 'heatwave', 'cable_half', 'plant_trip'],
  // Ét nyt i hvert år: værksnedbruddet (scriptet i år 1), kabelskaden, havet eller naboerne, gravkoen eller
  // varmen, og til sidst stormen.
  news: [['plant_trip'], ['cable_half'], ['anchor', 'protest'], ['digger', 'heatwave'], ['storm']],
  scripted: [
    // Det første værksnedbrud i år 1: lille nok til, at et svinghjul klarer det.
    { kind: 'plant_trip', at: [32, 40], strength: 1 },
    // Første kabelskade på Storebælt i starten af år 2.
    { kind: 'cable_half', at: [92, 100] },
    // Finalen: storm, et stort nedbrud, Storebælt halveret og et nedbrud mere.
    { kind: 'storm', at: 4, finale: true },
    { kind: 'plant_trip', at: 12, strength: 3, finale: true },
    { kind: 'cable_half', at: 20, finale: true },
    { kind: 'plant_trip', at: 32, strength: 2, finale: true },
  ],
  growth: [],
  boosts: [],
  years: 5,
  finaleS: 45,
  clockFrozenUntilYear: 0,
  startCrews: 2,
  startKr: 20,
  shipHome: 'herslev',
  crewHome: 'odense',
  packs: [
    ['flywheel', 'two_crews'],
    ['free_air3', 'big_battery'],
    ['flywheel', 'free_station'],
    ['two_crews', 'free_double'],
    ['big_battery', 'flywheel'],
  ],
};
